import { push } from 'connected-react-router';
import moment from 'moment';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAddBeneficiaryFormModal } from './addBeneficiaryFormModal';

export const ADD_BENE_FORM_REQUEST = 'ADD_BENE_FORM_REQUEST';
export const ADD_BENE_FORM_SUCCESS = 'ADD_BENE_FORM_SUCCESS';
export const ADD_BENE_FORM_FAILURE = 'ADD_BENE_FORM_FAILURE';
export const RESET_BENE_ADDING_FORM = 'RESET_BENE_ADDING_FORM';
export const CLOSE_PAYMENT_MODEL = 'CLOSE_PAYMENT_MODEL';
export const OPEN_PAYMENT_MODEL = 'OPEN_PAYMENT_MODEL';

function requestAddBeneForm() {
  return {
    type: ADD_BENE_FORM_REQUEST,
    isAddingBeneForm: true
  };
}

function receiveAddBeneForm(addingBeneFormResponse) {
  return {
    type: ADD_BENE_FORM_SUCCESS,
    isAddingBeneForm: false,
    addingBeneFormResponse
  };
}

function rejectAddBeneForm(addingBeneFormError) {
  return {
    type: ADD_BENE_FORM_FAILURE,
    isAddingBeneForm: false,
    addingBeneFormError
  };
}

function resetAddBeneForm() {
  return {
    type: RESET_BENE_ADDING_FORM,
    addingBeneFormError: null
  };
}

function showPaymentBreakdownModal(paymentValues) {
  return {
    type: OPEN_PAYMENT_MODEL,
    isPaymentModalShown: true,
    paymentValues
  };
}

function hidePaymentBreakdownModal() {
  return {
    type: CLOSE_PAYMENT_MODEL,
    isPaymentModalShown: false
  };
}

export function addBeneficiaryForm(data, parentW8ImyForm) {
  const formData = new FormData();

  formData.append('addImyToLayer', data.addImyToLayer !== 'true' && data.addImyToLayer !== true);
  if (data.addImyToLayer !== 'true' && data.addImyToLayer !== true) {
    data.formType = parentW8ImyForm.formType.toLowerCase();
  }

  if (data.formFile) {
    formData.append('pdfFile', data.formFile);
  }

  if (data.beneficiaryFormsOfW8BeneType) {
    const fileStore = data.beneficiaryFormsOfW8BeneType;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW8BeneType', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW8Bene2017Type) {
    const fileStore = data.beneficiaryFormsOfW8Bene2017Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        formData.append('beneficiaryFormsOfW8Bene2017Type', file);
      });
    }
  }

  if (data.beneficiaryFormsOfW8BenType) {
    const fileStore = data.beneficiaryFormsOfW8BenType;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW8BenType', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW8Ben2014Type) {
    const fileStore = data.beneficiaryFormsOfW8Ben2014Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW8Ben2014Type', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW9Type) {
    const fileStore = data.beneficiaryFormsOfW9Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW9Type', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW92017Type) {
    const fileStore = data.beneficiaryFormsOfW92017Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW92017Type', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW92018Type) {
    const fileStore = data.beneficiaryFormsOfW92018Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW92018Type', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW8ExpType) {
    const fileStore = data.beneficiaryFormsOfW8ExpType;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW8ExpType', file);
        }
      });
    }
  }

  if (data.beneficiaryFormsOfW8Exp2016Type) {
    const fileStore = data.beneficiaryFormsOfW8Exp2016Type;
    const arr = Array.from(fileStore);
    if (arr != null && arr.length > 0) {
      arr.forEach((file) => {
        if (file != null) {
          formData.append('beneficiaryFormsOfW8Exp2016Type', file);
        }
      });
    }
  }

  if (parentW8ImyForm) {
    formData.append('parentW8ImyId', parentW8ImyForm.id);
    if (parentW8ImyForm.taxRegimeType) {
      formData.append('taxEnumValue', parentW8ImyForm.taxRegimeType);
    }
  }

  formData.append('dateOfForm', `${ moment().format('MM-DD-YYYY') }`);
  formData.append('customerId', parentW8ImyForm.customerId);
  formData.append('isFFI', parentW8ImyForm.isFFI);

  return (dispatch) => {
    dispatch(requestAddBeneForm());

    const promise = () => ApiService
      .addBeneficiaryForm(data.formType, formData)
      .then((response) => {
        dispatch(hideAddBeneficiaryFormModal());
        dispatch(receiveAddBeneForm(response.data));
        return dispatch(push(`/forms/${ data.formType }/${ response.data }`));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddBeneForm));
        }
      });
    return promise();
  };
}

export function hideAddBeneFormError() {
  return dispatch => dispatch(resetAddBeneForm());
}

export function showPaymentModal(values) {
  return dispatch => dispatch(showPaymentBreakdownModal(values));
}

export function hidePaymentModal() {
  return dispatch => dispatch(hidePaymentBreakdownModal());
}
